<template>
	<div class="footer" v-if='status!="paysuccess"'>
    <p>Copyright © 2019  |  <a target="_blank" class="a-style" href="https://beian.miit.gov.cn">琼ICP备18001822号-3</a></p>
		<p>海南梯度网络科技有限公司</p>
	</div>
</template>
<script>
	export default {
		name: 'mobilefooter',// | 客服QQ：800800664
		data (){
			return {
				status:this.$store.state.status
			}
		}
	}
</script>

<style scoped>
  .footer{
    width: 100%;
    display: inline-block;
		margin-top: 0.005rem;
  }

  .footer p{
    font-size: 10px;
    color: #232323;
    letter-spacing: 0;
    text-align: center;
		line-height: 10px;
		margin-top: 0.625rem;
  }
	.a-style{
		color: #232323;
		text-decoration: none;
	}
	@media (min-width: 768px) {
		.footer p{
	    font-size: 12px;
	    color: #232323;
	    letter-spacing: 0;
	    text-align: center;
	    line-height: 22px;
	  }
	}
</style>



// WEBPACK FOOTER //
// src/mobilComponents/mobilFooter.vue